var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", { staticClass: "d-inline-flex mb-4" }, [
        _c("div", { staticClass: "form-check mr-3" }, [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.selectAll,
                expression: "selectAll"
              }
            ],
            staticClass: "form-check-input select-all mt-0",
            attrs: { type: "checkbox" },
            domProps: {
              checked: Array.isArray(_vm.selectAll)
                ? _vm._i(_vm.selectAll, null) > -1
                : _vm.selectAll
            },
            on: {
              change: function($event) {
                var $$a = _vm.selectAll,
                  $$el = $event.target,
                  $$c = $$el.checked ? true : false
                if (Array.isArray($$a)) {
                  var $$v = null,
                    $$i = _vm._i($$a, $$v)
                  if ($$el.checked) {
                    $$i < 0 && (_vm.selectAll = $$a.concat([$$v]))
                  } else {
                    $$i > -1 &&
                      (_vm.selectAll = $$a
                        .slice(0, $$i)
                        .concat($$a.slice($$i + 1)))
                  }
                } else {
                  _vm.selectAll = $$c
                }
              }
            }
          })
        ]),
        _vm._v(" "),
        _c("h4", { staticClass: "mr-3 mb-0", on: { click: _vm.test } }, [
          _vm._v("\n      Voice\n    ")
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "d-flex align-items-center mr-3" }, [
          _c(
            "span",
            {
              staticClass: "cursor-pointer",
              on: {
                click: function($event) {
                  return _vm.addNewTts()
                }
              }
            },
            [
              _c("img", {
                staticClass: "heading-icon",
                attrs: {
                  src: require("@/assets/addplus_icon.svg"),
                  width: "20"
                }
              })
            ]
          ),
          _vm._v(" "),
          _vm.isSelected
            ? _c(
                "span",
                {
                  staticClass: "cursor-pointer ml-3",
                  on: {
                    click: function($event) {
                      return _vm.deleteAllTts()
                    }
                  }
                },
                [_c("i", { staticClass: "fa fa-trash" })]
              )
            : _vm._e()
        ])
      ]),
      _vm._v(" "),
      _vm._l(_vm.tts_fields, function(ttsitem, index) {
        return _c(
          "div",
          {
            key: ttsitem.id,
            staticClass: "mb-3 inspectorElements",
            attrs: { id: ttsitem.id }
          },
          [
            _c(
              "div",
              { staticClass: "fields-wrapper is-divider is-multi-node" },
              [
                _c("div", { staticClass: "form-check select-single" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: ttsitem.textToSpeech.selectSingle,
                        expression: "ttsitem.textToSpeech.selectSingle"
                      }
                    ],
                    staticClass: "form-check-input",
                    attrs: { type: "checkbox" },
                    domProps: {
                      checked: Array.isArray(ttsitem.textToSpeech.selectSingle)
                        ? _vm._i(ttsitem.textToSpeech.selectSingle, null) > -1
                        : ttsitem.textToSpeech.selectSingle
                    },
                    on: {
                      change: function($event) {
                        var $$a = ttsitem.textToSpeech.selectSingle,
                          $$el = $event.target,
                          $$c = $$el.checked ? true : false
                        if (Array.isArray($$a)) {
                          var $$v = null,
                            $$i = _vm._i($$a, $$v)
                          if ($$el.checked) {
                            $$i < 0 &&
                              _vm.$set(
                                ttsitem.textToSpeech,
                                "selectSingle",
                                $$a.concat([$$v])
                              )
                          } else {
                            $$i > -1 &&
                              _vm.$set(
                                ttsitem.textToSpeech,
                                "selectSingle",
                                $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                              )
                          }
                        } else {
                          _vm.$set(ttsitem.textToSpeech, "selectSingle", $$c)
                        }
                      }
                    }
                  })
                ]),
                _vm._v(" "),
                !ttsitem.textToSpeech.isCopied ||
                ttsitem.textToSpeech.selectSingle
                  ? _c("div", { staticClass: "action-buttons" }, [
                      !ttsitem.textToSpeech.isCopied
                        ? _c(
                            "span",
                            {
                              staticClass: "action-item ",
                              on: {
                                click: function($event) {
                                  return _vm.copyTts(index, ttsitem)
                                }
                              }
                            },
                            [_c("i", { staticClass: "fa fa-copy" })]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      ttsitem.textToSpeech.selectSingle
                        ? _c(
                            "span",
                            {
                              staticClass: "action-item",
                              on: {
                                click: function($event) {
                                  return _vm.deleteTts(index, ttsitem)
                                }
                              }
                            },
                            [_c("i", { staticClass: "fa fa-trash" })]
                          )
                        : _vm._e()
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c("div", { staticClass: "row" }, [
                  _c("div", { staticClass: "col-6" }, [
                    _c(
                      "div",
                      { staticClass: "row form-group align-items-center" },
                      [
                        _c(
                          "label",
                          { staticClass: "col-sm-5 col-form-label" },
                          [_vm._v("\n              Voice Type\n            ")]
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "col-sm-7" }, [
                          _c(
                            "select",
                            {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: ttsitem.textToSpeech.gender,
                                  expression: "ttsitem.textToSpeech.gender"
                                }
                              ],
                              staticClass: "custom-select",
                              on: {
                                change: [
                                  function($event) {
                                    var $$selectedVal = Array.prototype.filter
                                      .call($event.target.options, function(o) {
                                        return o.selected
                                      })
                                      .map(function(o) {
                                        var val =
                                          "_value" in o ? o._value : o.value
                                        return val
                                      })
                                    _vm.$set(
                                      ttsitem.textToSpeech,
                                      "gender",
                                      $event.target.multiple
                                        ? $$selectedVal
                                        : $$selectedVal[0]
                                    )
                                  },
                                  function($event) {
                                    return _vm.getVoicesList(index)
                                  }
                                ]
                              }
                            },
                            _vm._l(_vm.voices, function(voice) {
                              return _c(
                                "option",
                                { key: _vm.voices.indexOf(voice) },
                                [_vm._v(_vm._s(voice) + "\n                ")]
                              )
                            }),
                            0
                          )
                        ])
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "row form-group align-items-center" },
                      [
                        _c(
                          "label",
                          { staticClass: "col-sm-5 col-form-label" },
                          [
                            _vm._v(
                              "\n              Select Language\n            "
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "col-sm-7" }, [
                          _c(
                            "select",
                            {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: ttsitem.textToSpeech.languageCode,
                                  expression:
                                    "ttsitem.textToSpeech.languageCode"
                                }
                              ],
                              staticClass: "custom-select",
                              on: {
                                change: [
                                  function($event) {
                                    var $$selectedVal = Array.prototype.filter
                                      .call($event.target.options, function(o) {
                                        return o.selected
                                      })
                                      .map(function(o) {
                                        var val =
                                          "_value" in o ? o._value : o.value
                                        return val
                                      })
                                    _vm.$set(
                                      ttsitem.textToSpeech,
                                      "languageCode",
                                      $event.target.multiple
                                        ? $$selectedVal
                                        : $$selectedVal[0]
                                    )
                                  },
                                  function($event) {
                                    return _vm.getVoiceEffects(index)
                                  }
                                ]
                              }
                            },
                            _vm._l(ttsitem.textToSpeech.voiceList, function(
                              voice
                            ) {
                              return _c(
                                "option",
                                {
                                  key: ttsitem.textToSpeech.voiceList.indexOf(
                                    voice
                                  ),
                                  domProps: { value: voice }
                                },
                                [
                                  _vm._v(
                                    _vm._s(voice.country) + "\n                "
                                  )
                                ]
                              )
                            }),
                            0
                          )
                        ])
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "row form-group align-items-center" },
                      [
                        _c(
                          "label",
                          { staticClass: "col-sm-5 col-form-label" },
                          [_vm._v("\n              Voice Effect\n            ")]
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "col-sm-7" }, [
                          _c(
                            "select",
                            {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: ttsitem.textToSpeech.voiceEffect,
                                  expression: "ttsitem.textToSpeech.voiceEffect"
                                }
                              ],
                              staticClass: "custom-select",
                              on: {
                                change: [
                                  function($event) {
                                    var $$selectedVal = Array.prototype.filter
                                      .call($event.target.options, function(o) {
                                        return o.selected
                                      })
                                      .map(function(o) {
                                        var val =
                                          "_value" in o ? o._value : o.value
                                        return val
                                      })
                                    _vm.$set(
                                      ttsitem.textToSpeech,
                                      "voiceEffect",
                                      $event.target.multiple
                                        ? $$selectedVal
                                        : $$selectedVal[0]
                                    )
                                  },
                                  function($event) {
                                    return _vm.getDataWithNewFields(index)
                                  }
                                ]
                              }
                            },
                            _vm._l(ttsitem.textToSpeech.voiceEffects, function(
                              effect
                            ) {
                              return _c(
                                "option",
                                {
                                  key: ttsitem.textToSpeech.voiceEffects.indexOf(
                                    effect
                                  ),
                                  domProps: { value: effect.name }
                                },
                                [
                                  _vm._v(
                                    _vm._s(effect.name) + "\n                "
                                  )
                                ]
                              )
                            }),
                            0
                          )
                        ])
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "row form-group align-items-center" },
                      [
                        _c(
                          "label",
                          { staticClass: "col-sm-5 col-form-label" },
                          [_vm._v("\n              Voice Text\n            ")]
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "col-sm-7" }, [
                          _c("textarea", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: ttsitem.textToSpeech.text,
                                expression: "ttsitem.textToSpeech.text"
                              }
                            ],
                            ref: "textToSpeech-" + index,
                            refInFor: true,
                            staticClass: "form-control",
                            attrs: {
                              rows: "4",
                              id: "targetIdle-" + index,
                              placeholder: "Please enter your voice text here"
                            },
                            domProps: { value: ttsitem.textToSpeech.text },
                            on: {
                              keyup: _vm.setTimer,
                              click: function($event) {
                                return _vm.deleteText(
                                  index,
                                  ttsitem.textToSpeech.text
                                )
                              },
                              input: function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.$set(
                                  ttsitem.textToSpeech,
                                  "text",
                                  $event.target.value
                                )
                              }
                            }
                          })
                        ])
                      ]
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-6" }, [
                    _c(
                      "div",
                      { staticClass: "row form-group align-items-center" },
                      [
                        _c(
                          "label",
                          { staticClass: "col-sm-5 col-form-label" },
                          [_vm._v("\n              Test Voice\n            ")]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "col-sm-7" },
                          [
                            !ttsitem.textToSpeech.hasOwnProperty(
                              "isAudioPlaying"
                            ) || !ttsitem.textToSpeech.isAudioPlaying
                              ? [
                                  _c(
                                    "button",
                                    {
                                      staticClass: "btn btn-outline-success",
                                      attrs: { id: "select_audio_duration_s" },
                                      on: {
                                        click: function($event) {
                                          return _vm.playTextToSpeech(index)
                                        }
                                      }
                                    },
                                    [_c("i", { staticClass: "fa fa-play" })]
                                  )
                                ]
                              : _vm._e(),
                            _vm._v(" "),
                            ttsitem.textToSpeech.hasOwnProperty(
                              "isAudioPlaying"
                            ) && ttsitem.textToSpeech.isAudioPlaying
                              ? [
                                  _c(
                                    "button",
                                    {
                                      staticClass: "btn btn-outline-warning",
                                      attrs: {
                                        id: "select_audio_duration_pause"
                                      },
                                      on: {
                                        click: function($event) {
                                          return _vm.pauseSound(index)
                                        }
                                      }
                                    },
                                    [
                                      _c("i", {
                                        staticClass: "fa fa-pause pause"
                                      })
                                    ]
                                  )
                                ]
                              : _vm._e(),
                            _vm._v(" "),
                            _c(
                              "button",
                              {
                                staticClass: "btn btn-outline-danger",
                                attrs: { id: "select_audio_duration_stop" },
                                on: {
                                  click: function($event) {
                                    return _vm.stopSound(index)
                                  }
                                }
                              },
                              [_c("i", { staticClass: "fa fa-stop" })]
                            )
                          ],
                          2
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "row form-group align-items-center" },
                      [
                        _c(
                          "label",
                          { staticClass: "col-sm-5 col-form-label" },
                          [_vm._v("\n              Voice Volume\n            ")]
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "col-sm-7" }, [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: ttsitem.textToSpeech.voiceVolume,
                                expression: "ttsitem.textToSpeech.voiceVolume"
                              }
                            ],
                            attrs: {
                              type: "range",
                              min: "0",
                              max: "10",
                              step: "0.5"
                            },
                            domProps: {
                              value: ttsitem.textToSpeech.voiceVolume
                            },
                            on: {
                              __r: function($event) {
                                return _vm.$set(
                                  ttsitem.textToSpeech,
                                  "voiceVolume",
                                  $event.target.value
                                )
                              }
                            }
                          }),
                          _vm._v(" "),
                          _c("span", { staticClass: "ml-3" }, [
                            _vm._v(_vm._s(ttsitem.textToSpeech.voiceVolume))
                          ])
                        ])
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "row form-group align-items-center" },
                      [
                        _c(
                          "label",
                          { staticClass: "col-sm-5 col-form-label" },
                          [_vm._v("\n              Start Time\n            ")]
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "col-sm-7" }, [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: ttsitem.textToSpeech.startTime,
                                expression: "ttsitem.textToSpeech.startTime"
                              }
                            ],
                            staticClass: "form-control",
                            attrs: {
                              type: "number",
                              id: index,
                              min:
                                index !== 0
                                  ? parseInt(
                                      _vm.tts_fields[index - 1].textToSpeech
                                        .endTime
                                    ) + parseInt(2)
                                  : 0
                            },
                            domProps: { value: ttsitem.textToSpeech.startTime },
                            on: {
                              blur: _vm.checkStartTime,
                              input: function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.$set(
                                  ttsitem.textToSpeech,
                                  "startTime",
                                  $event.target.value
                                )
                              }
                            }
                          })
                        ])
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "row form-group align-items-center" },
                      [
                        _c(
                          "label",
                          { staticClass: "col-sm-5 col-form-label" },
                          [_vm._v("\n              End Time\n            ")]
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "col-sm-7" }, [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: ttsitem.textToSpeech.endTime,
                                expression: "ttsitem.textToSpeech.endTime"
                              }
                            ],
                            staticClass: "form-control",
                            attrs: { type: "text", readonly: "" },
                            domProps: { value: ttsitem.textToSpeech.endTime },
                            on: {
                              input: function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.$set(
                                  ttsitem.textToSpeech,
                                  "endTime",
                                  $event.target.value
                                )
                              }
                            }
                          })
                        ])
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "row form-group align-items-center" },
                      [
                        _c(
                          "label",
                          { staticClass: "col-sm-5 col-form-label" },
                          [
                            _vm._v(
                              "\n              Duration (sec)\n            "
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "col-sm-7" }, [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: ttsitem.textToSpeech.duration,
                                expression: "ttsitem.textToSpeech.duration"
                              }
                            ],
                            staticClass: "form-control",
                            attrs: { type: "text", readonly: "" },
                            domProps: { value: ttsitem.textToSpeech.duration },
                            on: {
                              input: function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.$set(
                                  ttsitem.textToSpeech,
                                  "duration",
                                  $event.target.value
                                )
                              }
                            }
                          })
                        ])
                      ]
                    )
                  ])
                ])
              ]
            )
          ]
        )
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-19cbab88", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-19cbab88","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/v2/story-edit-view/inspector-components/character/tts.vue
// module id = null
// module chunks = 